const constants = {
  NOTIFICATION_STORE_MODULE_NAME: 'featureNotification',
}
export default constants
